import { CREDITS } from "../../constants";

export function capitalize(string) {
  if (string && string.length > 0) {
    let firstLetter = string[0];
    firstLetter = firstLetter.toUpperCase();
    string = string.replace(string[0], firstLetter);
  }
  return string;
}

export function imageExists(url) {
  return new Promise((resolve) => {
    let img = new Image();
    img.onload = function () {
      resolve(true);
    };
    img.onerror = function () {
      resolve(false);
    };
    img.src = url;
  });
}

export function debounce(func, delay = 500) {
  let time;
  return (...args) => {
    clearTimeout(time);
    time = setTimeout(() => {
      func.apply(this, args);
    }, delay);
  };
}

export function download_file(data, filename) {
  let blob = new Blob([data], { type: "text/csv" });
  let URL = window.URL.createObjectURL(blob);
  let tempLink = document.createElement("a");
  tempLink.href = URL;
  tempLink.setAttribute("download", filename);
  tempLink.click();
}
export function capitalizeFirstLetter(string) {
  return string && string.charAt(0).toUpperCase() + string.slice(1);
}
export function formatSubscribeInfo(data) {
  const subscription = data.items.filter(
    (item) => item.addedCredits && !item.creditType
  );
  const subscriptionNextPeriod = data.nextPeriodItems.filter(
    (item) => item.info == "Subscription"
  );
  const extraCredits = data.items.filter((item) => item.creditType);

  const extraCreditsToUpgrade = data.nextPeriodItems.filter(
    (item) => item.creditType
  );
  const vat = data.items.find((item) => item.info === "vat");
  const totalRenew = data.nextPeriodItems.reduce((accumulator, currentItem) => {
    return accumulator + currentItem.qt * currentItem.unitPrice;
  }, 0);
  const nextBillingAmount = data.nextPeriodItems.reduce(
    (accumulator, currentItem) => {
      return accumulator + currentItem.unitPrice;
    },
    0
  );
  const subscriptionTotal = subscription.reduce((accumulator, currentItem) => {
    return accumulator + currentItem.qt * currentItem.unitPrice;
  }, 0);
  const total = data.items.reduce((accumulator, currentItem) => {
    return accumulator + currentItem.qt * currentItem.unitPrice;
  }, 0);
  const credits = subscriptionNextPeriod.reduce(
    (accumulator, currentItem) => {
      return {
        workEmailCredits:
          accumulator.workEmailCredits +
          currentItem.addedCredits.workEmailCredits,
        personalEmailCredits:
          accumulator.personalEmailCredits +
          currentItem.addedCredits.personalEmailCredits,
        phoneCredits:
          accumulator.phoneCredits + currentItem.addedCredits.phoneCredits,
        exportCredits:
          accumulator.exportCredits + currentItem.addedCredits.exportCredits,
      };
    },
    {
      workEmailCredits: 0,
      personalEmailCredits: 0,
      phoneCredits: 0,
      exportCredits: 0,
    }
  );
  return {
    extraCredits,
    extraCreditsToUpgrade,
    vat,
    totalRenew,
    nextBillingAmount,
    subscriptionTotal,
    total,
    credits,
    isUpgrade: data.isUpgrade,
    automaticRenewal: !!data.nextPeriodItems.length,
    remainingMonths: data.remainingMonths,
  };
}
export function calculateRemaining(remaining, credits, type) {
  let totalRemaining = {};

  if (type) {
    for (let creditType of CREDITS) {
      totalRemaining[creditType] =
        remaining[
          creditType == "exportCredits" ? "organizationRemaining" : type
        ][creditType] || 0;
    }
    totalRemaining.isUnlimited =
      credits &&
      credits.personalCredits &&
      credits.personalCredits.recurrenceCredits &&
      credits.personalCredits.recurrenceCredits["workEmailCredits"].isUnlimited;

    totalRemaining.type = type;
    return totalRemaining;
  }

  for (let creditType of CREDITS) {
    totalRemaining[creditType] =
      (remaining.organizationRemaining[creditType] || 0) +
      (remaining.personalCredits[creditType] || 0);
  }
  totalRemaining.isUnlimited =
    credits &&
    credits.personalCredits &&
    credits.personalCredits.recurrenceCredits &&
    credits.personalCredits.recurrenceCredits["workEmailCredits"].isUnlimited;
  return totalRemaining;
}
